module.exports = ".layout-wrapper{background:#eff0f4;margin:0;height:100%}\n"